import script from "./PnlPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./PnlPage.vue?vue&type=script&setup=true&lang=ts"

import "./PnlPage.vue?vue&type=style&index=0&id=ab0d2562&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ab0d2562"]])

export default __exports__